export const BulkOperationActionTypeEnum = {
  RequestVacancy: {
    key: "request_vacancy",
    value: "request_vacancy",
  },
  ApprovalAction: {
    key: "approval_action",
    value: "approval_action",
  },
};
